import Vue from "vue";

Vue.component("crn-attachment-links", {
	props: ["notificationId"],
	data() {
		return {
			loading: false,
			loadingText: window.labels.loading,
			fullTextLink: htmlEntity.decode(window.labels.fullTextLink),
			crnAttachment: ''
		};
	},
	computed: {
		hasAttachment() {
			return this.crnAttachment ? true : false;
		},
	},
	methods: {
		getCRNAttachments: function () {
			this.loading = true;
			this.$services.notifications.getCRNAttachments({
					notificationId: this.notificationId,
					language: window.currentOfficialLanguageInt
				})
				.then((data) => {
					this.loading = false;
					this.crnAttachment = data;
				});
		},
	},
	mounted() {
		this.getCRNAttachments();
	},
	template: `
	<div>
		<div v-if="loading">
			<loading :loading-text="loadingText"></loading>
		</div>
		<div v-else-if="hasAttachment">
			<div v-html="crnAttachment"></div>
		</div>
	</div>
	`
});